var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
// 定义验证码的一些选择性数据
var colorArr = ['#000099', '#007d05', '#009688', '#f50000', '#1b9203', '#ba267a', '#960000', '#baa726', '#6666cc',
    '#cc6633', '#cc6633', '#3399cc', '#cc3333', '#336600', '#993333', '#ff9900', '#33cc99'];
var fontWeightArr = ['bold', 'lighter '];
var fontFamilyArr = ['Tahoma', 'Arial', 'Helvetica', 'Georgia', 'Lucida Grande', 'Times New Roman'];
var VerifyCode = /** @class */ (function (_super) {
    __extends(VerifyCode, _super);
    function VerifyCode() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.verifyCodeLength = 4;
        _this.verify = {
            code: ''
        };
        _this.verifyArray = [];
        return _this;
    }
    /**
     * 获取随机数值
     */
    VerifyCode.prototype.getValue = function () {
        return Math.random().toString(36).substr(7, 1);
    };
    /**
     * 获取验证码样式
     */
    VerifyCode.prototype.getStyle = function () {
        // 字体旋转样式
        var transformY = "translateY(" + Math.floor((Math.random() - 0.5) * 10) + "px)";
        var scale = "scale(" + (Math.random() + 0.8) + ")";
        var rotate = "rotate(" + Math.floor((Math.random() - 0.5) * 100) + "deg)";
        // 字体大小
        var fontSize = 18 + Math.floor((Math.random() - 0.5) * 2) + "px";
        // 随机字体颜色
        // let r = Math.floor(Math.random() * 256)
        // let g = Math.floor(Math.random() * 256)
        // let b = Math.floor(Math.random() * 256)
        // let fontColor = `rgb(${r + ',' + g + ',' + b})`
        var fontColor = "" + colorArr[Math.floor(Math.random() * colorArr.length)];
        // 固定字体类型
        var fontFamily = "" + fontFamilyArr[Math.floor(Math.random() * fontFamilyArr.length)];
        // 加粗
        var fontWeight = "" + fontWeightArr[Math.floor(Math.random() * fontWeightArr.length)];
        return {
            transform: transformY + " " + scale + " " + rotate,
            fontSize: fontSize,
            color: fontColor,
            fontFamily: fontFamily,
            fontWeight: fontWeight
        };
    };
    /**
     * 刷新验证码
     */
    VerifyCode.prototype.refresh = function () {
        var _this = this;
        var array = Array.from(Array(this.verifyCodeLength)).map(function (x) {
            return ({
                value: _this.getValue(),
                style: _this.getStyle()
            });
        });
        this.verifyArray = array;
    };
    /**
     * 验证码校验
     */
    VerifyCode.prototype.validate = function (rule, value, callback) {
        // 验证用户验证码输入
        var result = this.verifyArray.map(function (x) { return x.value; }).join('').toLocaleLowerCase() === this.verify.code.toLocaleLowerCase();
        return result;
    };
    /**
     * 获取验证码输入值
     */
    VerifyCode.prototype.getVerifyValue = function () {
        return this.verify.code;
    };
    VerifyCode.prototype.reset = function () {
        this.verify.code = '';
        this.refresh();
    };
    VerifyCode.prototype.mounted = function () {
        this.refresh();
    };
    VerifyCode = __decorate([
        Component({
            components: {}
        })
    ], VerifyCode);
    return VerifyCode;
}(Vue));
export default VerifyCode;
